<template>
  <q-page class="row items-center justify-center">
    <h2>&#xAF;\_(&#x30C4;)_/&#xAF;</h2>
    <h4>{{ code }}: <b>{{ message }}</b></h4>
  </q-page>
</template>

<script setup lang="ts">
defineOptions({ name: 'JErrorPage' })

defineProps({
  message: {
    type: String,
    required: true,
  },
  code: {
    type: Number,
    required: true,
  },
})
</script>
